module.exports = __webpack_public_path__ + "static/media/notFound.3bb05a56.svg";